import routes from './routes';
import reducer from './reducer';
import sagas from './sagas';

const addModule = {
  routes,
  reducer,
  sagas,
};
export default addModule;
